module.exports = __webpack_public_path__ + "img/section4_m.c3019a41.jpg";